import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Star } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Testimonials = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/reviews?limit=6`).then(r => setReviews((r.data || []).slice(0, 6))).catch(() => {});
  }, []);

  const fmtDate = (iso) => {
    try {
      const s = new Date(iso).toLocaleDateString('uk-UA', { month: 'long', year: 'numeric' });
      return s.charAt(0).toUpperCase() + s.slice(1);
    } catch { return ''; }
  };

  if (reviews.length === 0) return null;

  return (
    <section className="py-20 md:py-28 bg-[#060a13] relative overflow-hidden" data-testid="testimonials-section">
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-yellow-500/5 rounded-full" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Відгуки наших клієнтів</h2>
          <p className="text-lg text-slate-400">Що кажуть українці, які вже працюють з нами</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <div key={r.id} className="group bg-[#111827]/80 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6 hover:border-yellow-500/30 hover:shadow-[0_0_30px_-10px_rgba(234,179,8,0.3)] transition-all duration-500">
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map(s => (
                  <Star key={s} className={`w-4 h-4 ${s <= r.rating ? 'text-yellow-400 fill-yellow-400' : 'text-slate-600'}`} />
                ))}
              </div>
              <p className="text-slate-300 mb-4 leading-relaxed text-sm">{r.text}</p>
              <div className="flex items-center justify-between pt-3 border-t border-slate-700/50">
                <div>
                  <p className="font-semibold text-white text-sm">{r.name}</p>
                  {r.city && <p className="text-xs text-slate-500">{r.city}</p>}
                </div>
                <span className="text-xs text-slate-500">{fmtDate(r.created_at)}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link to="/vidguky" data-testid="all-reviews-link">
            <button className="px-8 py-3.5 rounded-full font-extrabold bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-[#1a0a00] shadow-[0_0_22px_rgba(251,146,60,0.55)] hover:shadow-[0_0_38px_rgba(251,146,60,0.9)] hover:scale-[1.03] transition-all">
              Всі відгуки · Залишити відгук ⭐
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};
